<template>
	<screen size="small" class="auth-view">
		<template slot="header">
			<div class="auth-header">
				<white-nav-bar route-name="login" back-or-close="close"
					>Reset Password</white-nav-bar
				>
			</div>
		</template>
		<div class="auth-content">
			<form v-on:submit.prevent="onSubmit">
				<p>Enter a new password below to finish the reset process.</p>
				<label>
					<ui-input
						type="password"
						placeholder="New Password"
						v-model="password"
					/>
				</label>
				<label>
					<ui-button native-type="submit" :loading="isLoading"
						>Submit</ui-button
					>
				</label>
			</form>
			<div class="roundup-row">
				<div class="forgot-password">
					<router-link :to="{ name: 'forgot-password' }"
						>Forgot Password?</router-link
					>
				</div>
				<div class="forgot-password">
					<router-link :to="{ name: 'login' }"
						>Back to Login</router-link
					>
				</div>
			</div>
		</div>
	</screen>
</template>

<script>
import { mapActions } from 'vuex'
import Screen from '../../ui/Screen'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import WhiteNavBar from '../../ui/WhiteNavBar'

export default {
	name: 'reset-password',
	components: { UiButton, UiInput, WhiteNavBar, Screen },
	props: ['uuid'],
	data() {
		return {
			isLoading: false,
			password: ''
		}
	},
	methods: {
		...mapActions(['resetPassword']),
		onSubmit() {
			this.isLoading = true
			this.resetPassword({ token: this.uuid, password: this.password })
				.then((response) => {
					this.isLoading = false
					this.$swal('Success', response.message).then(() => {
						this.navigate({ name: 'login' }, 'down')
					})
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		}
	}
}
</script>

<style lang="scss">
.screen {
	&.auth-view {
		.forgot-password {
			font-size: 13px;
		}
		.roundup-row {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}
	}
}
</style>
